import React, { useState } from 'react';

export default function ValidationPanel({ validation }) {
  const { summary, errors, warnings } = validation || {};
  const [open, setOpen] = useState(false);
  if (!validation) return null;

  return (
    <div className="border rounded-md bg-card p-3 text-[11px] space-y-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className={`px-2 py-0.5 rounded text-[10px] font-semibold ${summary.isValid ? 'bg-green-600/20 text-green-600' : 'bg-red-600/20 text-red-600'}`}>
            {summary.isValid ? 'VALID' : 'INVALID'}
          </span>
          <span className="text-textSecondary">{summary.errorCount} errors / {summary.warningCount} warnings</span>
        </div>
        <button
          type="button"
          onClick={()=>setOpen(o=>!o)}
          className="px-2 py-0.5 rounded border bg-muted/40 hover:bg-muted text-[10px]"
        >{open ? 'Hide' : 'Details'}</button>
      </div>
      {open && (
        <div className="space-y-2 max-h-52 overflow-auto pr-1">
          {errors.length === 0 && warnings.length === 0 && (
            <div className="text-textSecondary italic">No issues.</div>
          )}
          {errors.length > 0 && (
            <div>
              <div className="font-semibold mb-1 text-red-600">Errors</div>
              <ul className="space-y-0.5">
                {errors.map((e,i)=>(
                  <li key={i} className="flex gap-2">
                    <span className="text-red-600">•</span>
                    <span>{e.msg}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
          {warnings.length > 0 && (
            <div>
              <div className="font-semibold mb-1 text-amber-600">Warnings</div>
              <ul className="space-y-0.5">
                {warnings.map((w,i)=>(
                  <li key={i} className="flex gap-2">
                    <span className="text-amber-600">•</span>
                    <span>{w.msg}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
